<i18n src='@/locale/classification-map-localization.json'></i18n>

<template>
    <v-dialog
        v-model="vis"
        :max-width="maxWidth"
        :persistent="persistent"
        @keydown.escape="closeOnEsc && $emit('cancel')"
    >
        <v-card>
            <v-card-title v-if="formTitle">{{ formTitle }}</v-card-title>
            <v-card-text>
                <v-container>
                    <slot></slot>
                </v-container>
            </v-card-text>
            <v-card-actions v-if="!hideActions">
                <v-spacer></v-spacer>
                <slot name="actions">
                    <v-btn
                        @click="$emit('save')"
                        :disabled="disableSave"
                        class="primary white--text"
                        depressed
                    >
                        <v-icon left>save</v-icon>
                        {{ $t('Save') }}
                    </v-btn>
                    <v-btn
                        @click="$emit('cancel')"
                        :disabled="disableCancel"
                        color="blue darken-1"
                        text
                    >
                        {{ $t('Cancel') }}
                    </v-btn>
                </slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        formTitle: {
            type: String,
            required: true,
        },
        persistent: {
            type: Boolean,
            default: true,
        },
        disableSave: {
            type: Boolean,
            default: false,
        },
        disableCancel: {
            type: Boolean,
            default: false,
        },
        maxWidth: {
            type: String,
            default: '500px',
        },
        closeOnEsc: {
            type: Boolean,
            default: true,
        },
        hideActions: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        vis(val) {
            if (!val) {
                this.$emit('cancel');
            }
        },
    },
    data() {
        return {
            vis: true,
        };
    },
    methods: {
        CloseEditCreateDialog() {},
    },
};
</script>

<style>
</style>